<template>
  <div class="bg-gray-100 py-6" style="height:calc(100vh - 70px)">
    <div class="bg-white overflow-hidden shadow rounded-lg max-w-xl mx-auto">
      <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
        <div
          class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-no-wrap"
        >
          <div class="ml-4 mt-2">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Abandoned Carts Templates
            </h3>
          </div>
          <div class="ml-4 mt-2 flex-shrink-0">
            <span class="inline-flex rounded-md shadow-sm">
              <button
                type="button"
                class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                @click="createNew('Abandoned')"
              >
                Create new
              </button>
            </span>
          </div>
        </div>
      </div>
      <div>
        <!-- Content goes here -->
        <ul>
          <TemplateItem
            :template="template"
            @edit="onEdit($event, 'Abandoned')"
            @delete="onDelete($event, 'Abandoned')"
            v-for="template in templates"
            :key="template.id"
          />
        </ul>
      </div>
    </div>

    <div
      class="bg-white overflow-hidden shadow rounded-lg max-w-xl mx-auto mt-5"
    >
      <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
        <div
          class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-no-wrap"
        >
          <div class="ml-4 mt-2">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Order Templates
            </h3>
          </div>
          <div class="ml-4 mt-2 flex-shrink-0">
            <span class="inline-flex rounded-md shadow-sm">
              <button
                type="button"
                class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                @click="createNew('Order')"
              >
                Create new
              </button>
            </span>
          </div>
        </div>
      </div>
      <div>
        <!-- Content goes here -->
        <ul>
          <TemplateItem
            :template="template"
            @edit="onEdit($event, 'Order')"
            @delete="onDelete($event, 'Order')"
            v-for="template in orderTemplates"
            :key="template.id"
          />
        </ul>
      </div>
    </div>
    <TemplateModal
      v-if="showModal"
      :template="currentTemplate"
      @edit="onUpdate"
      @close="closeModal"
      @create="onCreate"
      :templateType="templateType"
    />
  </div>
</template>

<script>
import TemplateItem from "@/components/Common/TemplateItem.vue";
import TemplateModal from "@/components/Common/TemplateModal.vue";

export default {
  name: "Templates",
  components: {
    TemplateItem,
    TemplateModal
  },
  data() {
    return {
      showModal: false,
      currentTemplate: null,
      templateType: "Abandoned"
    };
  },
  computed: {
    templates() {
      return this.$store.getters.getTemplates;
    },
    orderTemplates() {
      return this.$store.getters.getOrderTemplates;
    }
  },
  created() {
    this.loadTemplates();
  },
  methods: {
    loadTemplates() {
      this.$store.dispatch("getTemplates");
      this.$store.dispatch("getOrderTemplates");
    },
    closeModal() {
      this.showModal = false;
    },
    openModal() {
      this.showModal = true;
    },
    createNew(templateType) {
      this.templateType = templateType;
      this.currentTemplate = null;
      this.openModal();
    },
    async onCreate({ body, name }) {
      if (this.templateType === "Abandoned") {
        await this.$store.dispatch("createTemplate", {
          requestParams: {
            body,
            name
          }
        });
      }

      if (this.templateType === "Order") {
        await this.$store.dispatch("createOrderTemplate", {
          requestParams: {
            body,
            name
          }
        });
      }

      this.loadTemplates();
    },
    async onUpdate({ body, name }) {
      if (this.templateType === "Abandoned") {
        await this.$store.dispatch("updateTemplate", {
          templateId: this.currentTemplate.id,
          requestParams: {
            body,
            name
          }
        });
      }

      if (this.templateType === "Order") {
        await this.$store.dispatch("updateOrderTemplate", {
          templateId: this.currentTemplate.id,
          requestParams: {
            body,
            name
          }
        });
      }

      this.loadTemplates();
    },
    onEdit(template, templateType) {
      this.currentTemplate = template;
      this.templateType = templateType;
      this.openModal();
    },
    async onDelete(template, templateType) {
      this.templateType = templateType;
      if (this.templateType === "Abandoned") {
        await this.$store.dispatch("deleteTemplate", {
          templateId: template.id
        });
      }
      if (this.templateType === "Order") {
        await this.$store.dispatch("deleteOrderTemplate", {
          templateId: template.id
        });
      }
      this.loadTemplates();
    }
  }
};
</script>

<style lang="scss" scoped></style>
